import React from "react";
import "./App.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { Outlet } from "react-router-dom";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { MantineProvider, createTheme } from "@mantine/core";
import { AuthProvider } from "./auth/hooks/authProvider";

const theme = createTheme({
  fontFamily: "Montserrat, sans-serif",
  defaultRadius: "md",
  colors: {
    primary: [
      "#f3e9f8", // Lighter shade of #221E45
      "#e1c5f0",
      "#d0a1e8",
      "#bf7de0",
      "#ae59d8",
      "#9d35d0",
      "#8c11c8",
      "#7a0fc0",
      "#680db8",
      "#560bb0",
    ],
    accent: [
      "#ffe8e1", // Lighter shade of #FC7A69
      "#ffd4c7",
      "#ffc0ad",
      "#ffac93",
      "#ff9879",
      "#ff845f",
      "#ff7045",
      "#fc5c2b",
      "#e84817",
      "#d43403",
    ],
  },
  primaryColor: "primary",
});

export default function App() {
  return (
    <AuthProvider>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          <div className="min-h-screen bg-gray-50">
            <Outlet />
          </div>
        </ModalsProvider>
        <Notifications />
      </MantineProvider>
    </AuthProvider>
  );
}
